const HeaderConfigSZ = {
  TEXT_BACK: 'назад',
};

export { HeaderConfigSZ };
